{
    "NAME": "Impostazioni di registrazioneLingua",
    "LoggingSettings_Column_Component": "Componente",
    "LoggingSettings_Column_Enabled": "Abilitato",
    "LoggingSettings_Column_BackupLogs": "Registri di backup",
    "LoggingSettings_Column_Level": "Livello",
    "LoggingSettings_Column_RollOverFiles": "File di rollover",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Dimensione massima del file (MB)",
    "LoggingSettings_Component_MainServlet": "Servlet principale",
    "LoggingSettings_Component_Database": "Schermata",
    "LoggingSettings_Component_Repository": "Archivio",
    "LoggingSettings_Component_RptExecMgr": "Responsabile dell'esecuzione dei report",
    "LoggingSettings_Component_MailController": "Responsabile della posta",
    "LoggingSettings_Component_TaskDelegator": "Delegatore di compiti",
    "LoggingSettings_Component_TelephoneModule": "Modulo telefonico",
    "LoggingSettings_Component_OmniModule": "Modulo omnicanale",
    "LoggingSettings_Action_Save": "Salva",
    "LoggingSettings_Action_Cancel": "Cancellare",
    "LoggingSettings_Action_Refresh": "Rinfrescato",
    "LoggingSettings_ReadOnlyWarning": "Non si dispone dei privilegi di amministratore globale per aggiornare le impostazioni di registrazione.",
    "LoggingSettings_SaveSuccess": "Le impostazioni di registrazione sono state salvate.",
    "LoggingSettings_SaveError": "Impossibile salvare le impostazioni di registrazione.",
    "LoggingSettings_RefreshConfirmTitle": "Annullare le modifiche non salvate?",
    "LoggingSettings_RefreshConfirmBody": "Aggiornando la pagina, le modifiche non salvate verranno perse. Continuare?",
    "LoggingSettings_Empty": "Non sono disponibili impostazioni di registrazione."
}